import { render, staticRenderFns } from "./PreonboardingNotification.vue?vue&type=template&id=5bd113ff&scoped=true"
import script from "./PreonboardingNotification.vue?vue&type=script&lang=js"
export * from "./PreonboardingNotification.vue?vue&type=script&lang=js"
import style0 from "./PreonboardingNotification.vue?vue&type=style&index=0&id=5bd113ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd113ff",
  null
  
)

export default component.exports